export class UserNotFoundError extends Error {
  constructor() {
    super();
    this.code = 'auth/user-not-found';
  }
}

export class UserAlreadyExist extends Error {
  constructor() {
    super();
    this.code = 'auth/uid-already-exists';
  }
}

export class UserIsSuspendedError extends Error {
  constructor() {
    super();
    this.code = 'auth/user-suspended';
  }
}
